"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6926],{

/***/ 56374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DragDropResumeUpload$1; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/resumes/index.js
var resumes = __webpack_require__(93843);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/resumes/const.js
var resumes_const = __webpack_require__(14313);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/UploadIcon/index.js
'use client';




function UploadIcon(_a) {
    var _b = _a.color, color = _b === void 0 ? "".concat(Colors/* colors.primary.40 */.O9.primary[40]) : _b, _c = _a.width, width = _c === void 0 ? 19 : _c, _d = _a.height, height = _d === void 0 ? 21 : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 19 21', fill: 'none' },
        react.createElement("path", { d: 'M2.10073 0C1.21673 0 0.500732 0.716 0.500732 1.6V15.2C0.500732 16.084 1.21673 16.8 2.10073 16.8H8.50073V6.73125L6.66636 8.56562C6.35356 8.87842 5.84791 8.87842 5.53511 8.56562C5.22231 8.25282 5.22231 7.74717 5.53511 7.43437L8.73511 4.23437C8.89111 4.07837 9.09593 4 9.30073 4C9.50553 4 9.71036 4.07837 9.86636 4.23437L13.0664 7.43437C13.3792 7.74717 13.3792 8.25282 13.0664 8.56562C12.7536 8.87842 12.2479 8.87842 11.9351 8.56562L10.1007 6.73125V16.8H16.5007C17.3847 16.8 18.1007 16.084 18.1007 15.2V1.6C18.1007 0.716 17.3847 0 16.5007 0H2.10073ZM10.1007 16.8H8.50073V20C8.50073 20.4416 8.85913 20.8 9.30073 20.8C9.74233 20.8 10.1007 20.4416 10.1007 20V16.8Z', fill: color })));
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/LoadingIcon/index.js
var LoadingIcon = __webpack_require__(50293);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/DragDropResumeUpload/styles.css.js
var styles_css = __webpack_require__(42661);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/DragDropResumeUpload/translations.js
'use client';

var translations = {
    'Upload file from your device': 'Chọn hồ sơ từ máy của bạn',
    '.doc, .docx and .pdf files that are less than 5120KB in size': 'Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB',
    or: 'hoặc',
    'Choose file to upload': 'Chọn hồ sơ từ máy bạn',
    'Drag your file here': 'Kéo hồ sơ của bạn vào đây',
    'Upload success': 'Tải lên thành công',
    'Replace file': 'Thay thế hồ sơ',
    'Your upload was successful': 'Tải lên thành công',
    'Drag & drop your CV here to quickly create your profile with AI': 'Kéo thả CV của bạn để tạo nhanh hồ sơ với AI'
};


//# sourceMappingURL=translations.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/DragDropResumeUpload/type.js
var type = __webpack_require__(65834);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/DragDropResumeUpload/constants.js
'use client';



var DEFAULT_DRAG_DROP_FILE_STYLE = {
    borderColor: Colors/* colors.primary.30 */.O9.primary[30],
    backgroundColor: Colors/* colors.primary.100 */.O9.primary[100]
};
var DEFAULT_SECONDARY_DRAG_DROP_FILE_STYLE = {
    borderColor: Colors/* colors.grey.60 */.O9.grey[60],
    backgroundColor: Colors/* colors.grey.99 */.O9.grey[99]
};


//# sourceMappingURL=constants.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Typography/index.js + 2 modules
var Typography = __webpack_require__(17739);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/SuccessIcon/index.js
var SuccessIcon = __webpack_require__(85658);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/DocumentsIcon/index.js
'use client';




function DocumentsIcon(_a) {
    var _b = _a.color, color = _b === void 0 ? "".concat(Colors/* colors.primary.40 */.O9.primary[40]) : _b, _c = _a.width, width = _c === void 0 ? 21 : _c, _d = _a.height, height = _d === void 0 ? 21 : _d, style = _a.style;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', style: style, width: width, height: height, viewBox: '0 0 21 21', fill: 'none' },
        react.createElement("path", { d: 'M16.971 6.36265L12.6377 2.02932C12.5123 1.90398 12.343 1.83398 12.1663 1.83398H5.16634C4.42967 1.83398 3.83301 2.43065 3.83301 3.16732V17.834C3.83301 18.5707 4.42967 19.1673 5.16634 19.1673H15.833C16.5697 19.1673 17.1663 18.5707 17.1663 17.834V6.83398C17.1663 6.65732 17.0963 6.48798 16.971 6.36265ZM12.4997 14.5007H7.16634C6.79834 14.5007 6.49967 14.202 6.49967 13.834C6.49967 13.466 6.79834 13.1673 7.16634 13.1673H12.4997C12.8677 13.1673 13.1663 13.466 13.1663 13.834C13.1663 14.202 12.8677 14.5007 12.4997 14.5007ZM13.833 11.834H7.16634C6.79834 11.834 6.49967 11.5353 6.49967 11.1673C6.49967 10.7993 6.79834 10.5007 7.16634 10.5007H13.833C14.201 10.5007 14.4997 10.7993 14.4997 11.1673C14.4997 11.5353 14.201 11.834 13.833 11.834ZM12.4997 7.16732C12.1317 7.16732 11.833 6.86865 11.833 6.50065V3.10332L15.897 7.16732H12.4997Z', fill: color })));
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Typography/components/Variant.js + 1 modules
var Variant = __webpack_require__(73851);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/UploadResumeModal/apiServices.js
var apiServices = __webpack_require__(84214);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js + 1 modules
var helpers = __webpack_require__(75052);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/model/index.js
var model = __webpack_require__(90222);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/AddFilledIcon/index.js
var AddFilledIcon = __webpack_require__(94864);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/Documentv2Icon/index.js
'use client';



var Documentv2Icon = function (props) {
    var _a = props.className, className = _a === void 0 ? '' : _a, _b = props.width, width = _b === void 0 ? 50 : _b, _c = props.height, height = _c === void 0 ? 53 : _c, style = props.style, _d = props.color, color = _d === void 0 ? '#0047CC' : _d;
    return (react.createElement("svg", { width: width, height: height, className: className, style: style, viewBox: '0 0 50 54', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { id: 'Documents', clipPath: 'url(#clip0_29878_281683)' },
            react.createElement("path", { id: 'Vector', d: 'M3.60039 17.4C1.83239 17.4 0.400391 18.832 0.400391 20.6V49.4C0.400391 51.168 1.83239 52.6 3.60039 52.6H6.09102C5.54062 51.6544 5.20039 50.5712 5.20039 49.4V20.6C5.20039 19.4288 5.54062 18.3456 6.09102 17.4H3.60039ZM11.6004 17.4C9.83239 17.4 8.40039 18.832 8.40039 20.6V49.4C8.40039 51.168 9.83239 52.6 11.6004 52.6H32.4004C34.1684 52.6 35.6004 51.168 35.6004 49.4V27.8C35.6004 27.376 35.4324 26.9695 35.1316 26.6687L26.3316 17.8687C26.0308 17.5679 25.6244 17.4 25.2004 17.4H11.6004ZM24.4004 20.4469L32.5535 28.6H26.0004C25.1172 28.6 24.4004 27.8832 24.4004 27V20.4469ZM16.4004 35H27.6004C28.4836 35 29.2004 35.7168 29.2004 36.6C29.2004 37.4832 28.4836 38.2 27.6004 38.2H16.4004C15.5172 38.2 14.8004 37.4832 14.8004 36.6C14.8004 35.7168 15.5172 35 16.4004 35ZM16.4004 41.4H24.4004C25.2836 41.4 26.0004 42.1168 26.0004 43C26.0004 43.8832 25.2836 44.6 24.4004 44.6H16.4004C15.5172 44.6 14.8004 43.8832 14.8004 43C14.8004 42.1168 15.5172 41.4 16.4004 41.4Z', fill: color }),
            react.createElement("path", { id: 'Vector_2', d: 'M31.2538 2.78088C30.8555 2.9125 30.8555 3.47613 31.2538 3.60663C32.1718 3.90813 32.8918 4.62925 33.1944 5.54725C33.326 5.9455 33.8896 5.9455 34.0201 5.54725C34.3216 4.62925 35.0428 3.90925 35.9608 3.60663C36.359 3.475 36.359 2.91138 35.9608 2.78088C35.0428 2.47938 34.3228 1.75825 34.0201 0.840252C33.8885 0.442002 33.3249 0.442002 33.1944 0.840252C32.8918 1.75938 32.1718 2.47938 31.2538 2.78088ZM43.8943 2.10588C43.739 1.63338 43.0696 1.63338 42.9144 2.10588L42.1876 4.31763C41.8299 5.40663 40.9749 6.2605 39.887 6.61825L37.6753 7.345C37.2028 7.50025 37.2028 8.16963 37.6753 8.32488L39.887 9.05163C40.976 9.40938 41.8299 10.2644 42.1876 11.3523L42.9144 13.564C43.0696 14.0365 43.739 14.0365 43.8943 13.564L44.6221 11.3523C44.9799 10.2633 45.8338 9.40938 46.9228 9.05163L49.1345 8.32488C49.607 8.16963 49.607 7.50025 49.1345 7.345L46.9228 6.61713C45.8338 6.25938 44.9799 5.4055 44.6221 4.3165L43.8943 2.10588ZM36.1599 11.3871C36.0046 10.9146 35.3353 10.9146 35.18 11.3871L35.0911 11.6583C34.7334 12.7473 33.8795 13.6011 32.7905 13.9589L32.5194 14.0478C32.0469 14.203 32.0469 14.8724 32.5194 15.0276L32.7905 15.1165C33.8795 15.4743 34.7334 16.3281 35.0911 17.4171L35.18 17.6883C35.3353 18.1608 36.0046 18.1608 36.1599 17.6883L36.2488 17.4171C36.6065 16.3281 37.4615 15.4743 38.5494 15.1165L38.8205 15.0276C39.293 14.8724 39.293 14.203 38.8205 14.0478L38.5494 13.9589C37.4604 13.6011 36.6065 12.7461 36.2488 11.6583L36.1599 11.3871Z', fill: color })),
        react.createElement("defs", null,
            react.createElement("clipPath", { id: 'clip0_29878_281683' },
                react.createElement("rect", { width: '50', height: '53', fill: 'white', transform: 'translate(0 0.5)' })))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Contexts/translator/helper.js
'use client';



var translator = function (txt, resource, language) {
    if (!(resource === null || resource === void 0 ? void 0 : resource[txt]))
        return txt;
    switch (language) {
        case constants/* ELanguage.EN */.Df.EN:
            return txt;
        case constants/* ELanguage.VI */.Df.VI:
            return resource[txt];
        default:
            return txt;
    }
};


//# sourceMappingURL=helper.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/DragDropResumeUpload/index.js
'use client';



























var DragDropResumeUpload = function (_a, ref) {
    var _b;
    var accessToken = _a.accessToken, _c = _a.lang, lang = _c === void 0 ? constants/* ELanguage.VI */.Df.VI : _c, baseUrl = _a.baseUrl, userId = _a.userId, jobId = _a.jobId, contentOptions = _a.contentOptions, onUpload = _a.onUpload, onUploadDone = _a.onUploadDone, onUploadError = _a.onUploadError, isUploadResume = _a.isUploadResume, dragDropStyle = _a.dragDropStyle, _d = _a.boxType, boxType = _d === void 0 ? type/* EBoxType.primary */.Y.primary : _d, // read docs stories book for more information,
    style = _a.style, fileInfo = _a.fileInfo, _e = _a.apiUploadVersion, apiUploadVersion = _e === void 0 ? 'v2.0' : _e, _f = _a.isCheckSpam, isCheckSpam = _f === void 0 ? true : _f, _g = _a.isLoading, isLoading = _g === void 0 ? false : _g, _h = _a.isNewUploadUI, isNewUploadUI = _h === void 0 ? false : _h;
    var _j = (0,react.useState)(false), isDrag = _j[0], setIsDrag = _j[1];
    var _k = (0,react.useState)(false), isError = _k[0], setIsError = _k[1];
    var _l = (0,react.useState)((_b = contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.msg) !== null && _b !== void 0 ? _b : null), message = _l[0], setMessage = _l[1];
    var _m = (0,react.useState)(!(fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.name) ? 'none' : 'success'), uploadStatus = _m[0], setUploadStatus = _m[1];
    var _o = (0,react.useState)(fileInfo), file = _o[0], setFile = _o[1];
    var inputRef = (0,react.useRef)(null);
    var unitId = (0,helpers/* randomId */.kb)();
    var mergedDragDropStyles = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, (boxType === type/* EBoxType.secondary */.Y.secondary ? DEFAULT_SECONDARY_DRAG_DROP_FILE_STYLE : DEFAULT_DRAG_DROP_FILE_STYLE)), dragDropStyle);
    var t = function (txt) {
        var text = translator(txt, translations, lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI);
        return text;
    };
    var validateResume = function (uploadFileInfo) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return (0,_tslib/* __generator */.Jh)(this, function (_j) {
            switch (_j.label) {
                case 0:
                    _j.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0,resumes/* validateFile */.D0)({
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            langCode: lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI,
                            file: uploadFileInfo,
                            baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                            userId: userId !== null && userId !== void 0 ? userId : 0,
                            jobId: jobId !== null && jobId !== void 0 ? jobId : 0
                        })];
                case 1:
                    response = _j.sent();
                    if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.attributes) && !((_c = (_b = response.data) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.spam)) {
                        !isUploadResume &&
                            setMessage(((_d = response.meta) === null || _d === void 0 ? void 0 : _d.statusCode) === 200
                                ? t('Your upload was successful')
                                : (_f = (_e = response === null || response === void 0 ? void 0 : response.meta) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : '');
                        !isUploadResume && setUploadStatus('success');
                        setIsError(false);
                        !isUploadResume && onUpload ? onUpload(uploadFileInfo) : null;
                        return [2 /*return*/, true];
                    }
                    setMessage((_h = (_g = response === null || response === void 0 ? void 0 : response.meta) === null || _g === void 0 ? void 0 : _g.message) !== null && _h !== void 0 ? _h : '');
                    setUploadStatus('none');
                    setIsError(true);
                    return [2 /*return*/, false];
                case 2:
                    error_1 = _j.sent();
                    setUploadStatus('none');
                    console.error(error_1);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var reset = function () {
        var _a;
        if (inputRef.current) {
            setMessage((_a = contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.msg) !== null && _a !== void 0 ? _a : '');
            inputRef.current.value = '';
            if (!/safari/i.test(navigator.userAgent)) {
                inputRef.current.type = '';
                inputRef.current.type = 'file';
            }
        }
    };
    var doUploadFile = function (file, resumeId, customResponseMessage, action) {
        if (resumeId === void 0) { resumeId = -1; }
        if (customResponseMessage === void 0) { customResponseMessage = ''; }
        if (action === void 0) { action = -1; }
        return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
            var requestParams, response, responseMessage, jobAlertData, error_2;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return (0,_tslib/* __generator */.Jh)(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        if (!file)
                            return [2 /*return*/, null];
                        _l.label = 1;
                    case 1:
                        _l.trys.push([1, 7, , 8]);
                        if (isLoading)
                            setUploadStatus('processing');
                        requestParams = {
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            langCode: lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI,
                            file: file,
                            baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                            resumeId: resumeId,
                            apiUploadVersion: apiUploadVersion
                        };
                        if (action !== -1) {
                            requestParams.action = action;
                        }
                        return [4 /*yield*/, (0,resumes/* uploadFile */.cT)(requestParams)];
                    case 2:
                        response = _l.sent();
                        if (response instanceof model/* default */.Z) {
                            setIsError(true);
                            setUploadStatus('none');
                            setMessage((_b = (_a = response === null || response === void 0 ? void 0 : response.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : '');
                            onUploadError && onUploadError(response);
                            return [2 /*return*/, null];
                        }
                        if (!(response && response.data)) return [3 /*break*/, 5];
                        onUploadDone && onUploadDone(response);
                        responseMessage = customResponseMessage !== '' ? customResponseMessage : (_c = response === null || response === void 0 ? void 0 : response.message) !== null && _c !== void 0 ? _c : '';
                        setMessage(response.status === 200 ? t('Your upload was successful') : responseMessage);
                        setFile({
                            name: (_e = (_d = response.data) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : ' ',
                            link: (_g = (_f = response.data) === null || _f === void 0 ? void 0 : _f.link) !== null && _g !== void 0 ? _g : '',
                            id: (_j = (_h = response.data) === null || _h === void 0 ? void 0 : _h.id) !== null && _j !== void 0 ? _j : 0
                        });
                        jobAlertData = response.data.job_alert_data;
                        if (!((jobAlertData === null || jobAlertData === void 0 ? void 0 : jobAlertData.summary) && jobAlertData.summary !== '')) return [3 /*break*/, 4];
                        return [4 /*yield*/, (0,apiServices/* updateSummaryProfileSetting */.ni)({
                                url: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                                summary: (_k = jobAlertData.summary) !== null && _k !== void 0 ? _k : '',
                                accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : ''
                            })];
                    case 3:
                        _l.sent();
                        _l.label = 4;
                    case 4:
                        setUploadStatus('success');
                        setIsError(false);
                        return [2 /*return*/, response.data];
                    case 5:
                        onUploadError && onUploadError(response);
                        _l.label = 6;
                    case 6: return [2 /*return*/, null];
                    case 7:
                        error_2 = _l.sent();
                        setUploadStatus('none');
                        console.error(error_2);
                        return [2 /*return*/, null];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    (0,react.useImperativeHandle)(ref, function () {
        return {
            reset: reset,
            doUploadFile: function (file, resumeId, customResponseMessage, action) {
                if (customResponseMessage === void 0) { customResponseMessage = ''; }
                if (action === void 0) { action = -1; }
                return doUploadFile(file, resumeId, customResponseMessage, action);
            }
        };
    }, [accessToken]);
    var checkUploadFile = function (file) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var uploadFileInfo, isValid, _a;
        var _b;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setUploadStatus('processing');
                    uploadFileInfo = file;
                    // check file extensions
                    if (!resumes_const/* DEFAULT_ALLOW_FILES_EXT.includes */.Ri.includes(uploadFileInfo.type)) {
                        // show error file type doesn't support
                        setMessage(t('.doc, .docx and .pdf files that are less than 5120KB in size'));
                        setIsError(true);
                        setUploadStatus('none');
                        return [2 /*return*/];
                    }
                    // check file size
                    if (uploadFileInfo.size > resumes_const/* DEFAULT_LIMIT_FILE_SIZE */.hS) {
                        // File is over 5MB
                        setMessage(t('.doc, .docx and .pdf files that are less than 5120KB in size'));
                        setIsError(true);
                        setUploadStatus('none');
                        return [2 /*return*/];
                    }
                    // validate spam cv
                    setMessage((_b = contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.msg) !== null && _b !== void 0 ? _b : '');
                    if (!isCheckSpam) return [3 /*break*/, 2];
                    return [4 /*yield*/, validateResume(file)];
                case 1:
                    _a = _c.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = true;
                    _c.label = 3;
                case 3:
                    isValid = _a;
                    // do upload file
                    if (isUploadResume && isValid) {
                        doUploadFile(uploadFileInfo);
                    }
                    if (!isCheckSpam && !isUploadResume) {
                        setIsError(false);
                        setUploadStatus('success');
                        onUpload && onUpload(file);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleOnFileChange = function (e) {
        if (e.target.files !== null && e.target.files.length > 0) {
            checkUploadFile(e.target.files[0]);
        }
    };
    var handleOnDragEnter = function (e) {
        e.preventDefault();
        setIsDrag(true);
    };
    var handleOnDragLeave = function (e) {
        e.preventDefault();
        setIsDrag(false);
    };
    var handleOnDragOver = function (e) {
        e.preventDefault();
    };
    var handleOnDrop = function (e) {
        e.stopPropagation();
        e.preventDefault();
        setIsDrag(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            e.dataTransfer.clearData();
            checkUploadFile(e.dataTransfer.files[0]);
        }
    };
    var renderIcon = function () {
        switch (uploadStatus) {
            case 'none':
                // Removed settingIcon
                return react.createElement(AddFilledIcon/* default */.Z, null);
            case 'processing':
                return react.createElement(LoadingIcon/* default */.Z, null);
            case 'success':
                return boxType === type/* EBoxType.primary */.Y.primary ? react.createElement(UploadIcon, null) : react.createElement(SuccessIcon/* default */.Z, { width: 24, height: 24 });
            default:
                return null;
        }
    };
    var renderLabel = function () {
        if (boxType === type/* EBoxType.primary */.Y.primary) {
            return t('Upload file from your device');
        }
        switch (uploadStatus) {
            case 'success':
                return t('Upload success');
            default:
                return t('Drag your file here');
        }
    };
    var renderResponseMsgColor = function () {
        switch (boxType) {
            case type/* EBoxType.primary */.Y.primary:
                return isError ? Colors/* colors.error.40 */.O9.error[40] : Colors/* colors.grey.60 */.O9.grey[60];
            case type/* EBoxType.secondary */.Y.secondary:
                if (uploadStatus === 'success') {
                    return Colors/* colors.grey.20 */.O9.grey[20];
                }
                return isError ? Colors/* colors.error.40 */.O9.error[40] : Colors/* colors.grey.60 */.O9.grey[60];
            default:
                return isError ? Colors/* colors.error.40 */.O9.error[40] : Colors/* colors.grey.60 */.O9.grey[60];
        }
    };
    (0,react.useEffect)(function () {
        var _a;
        setIsError(!!(contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.errMsg));
        setMessage((_a = contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.errMsg) !== null && _a !== void 0 ? _a : t('.doc, .docx and .pdf files that are less than 5120KB in size'));
    }, [contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.errMsg]);
    if (isNewUploadUI) {
        return (react.createElement(styles_css/* NewUIContainer */.v2, { style: style, className: 'body__uploadCV', htmlFor: "upload_cv_".concat(unitId), onDragEnter: handleOnDragEnter, onDragLeave: handleOnDragLeave, onDragOver: handleOnDragOver, onDrop: handleOnDrop, active: isDrag, disable: false, boxType: boxType, dragDropStyles: mergedDragDropStyles },
            react.createElement(styles_css/* IconWrapper */.a1, null,
                react.createElement(Documentv2Icon, null)),
            react.createElement("input", { id: "upload_cv_".concat(unitId), type: 'file', ref: inputRef, accept: resumes_const/* DEFAULT_ALLOW_EXT */.Wx, onChange: handleOnFileChange }),
            react.createElement(styles_css/* InfoMessage */.$J, null, t('Drag & drop your CV here to quickly create your profile with AI')),
            react.createElement(styles_css/* ResponseMsg */.bU, { variant: 'p', name: 'body', size: boxType === type/* EBoxType.primary */.Y.primary ? 'small' : 'medium', isPlaceholder: !isError, color: renderResponseMsgColor() }, message || t('.doc, .docx and .pdf files that are less than 5120KB in size')),
            react.createElement(styles_css/* Placeholder */.Vm, { boxType: boxType },
                react.createElement(Button/* default */.Z, { isRounded: true, type: 'highlight', outline: 'outline', size: 'sm', onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }, (contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.placeholder) || renderLabel()))));
    }
    return (react.createElement(styles_css/* Container */.W2, { style: style, className: 'body__uploadCV', htmlFor: "upload_cv_".concat(unitId), onDragEnter: handleOnDragEnter, onDragLeave: handleOnDragLeave, onDragOver: handleOnDragOver, onDrop: handleOnDrop, active: isDrag, disable: false, boxType: boxType, dragDropStyles: mergedDragDropStyles },
        react.createElement("input", { id: "upload_cv_".concat(unitId), type: 'file', ref: inputRef, accept: resumes_const/* DEFAULT_ALLOW_EXT */.Wx, onChange: handleOnFileChange }),
        react.createElement(styles_css/* Placeholder */.Vm, { boxType: boxType },
            react.createElement(Button/* default */.Z, { iconPosition: 'left', iconComponent: renderIcon(), isRounded: true, type: 'highlight', onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }, (contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.placeholder) || renderLabel()),
            boxType === type/* EBoxType.secondary */.Y.secondary && (react.createElement(react.Fragment, null, !(file === null || file === void 0 ? void 0 : file.name) ? (react.createElement(react.Fragment, null,
                react.createElement(Typography/* default */.Z, { variant: 'p', name: 'body', size: 'medium', color: Colors/* colors.grey.20 */.O9.grey[20] }, t('or')),
                react.createElement(Button/* default */.Z, { onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, type: 'primary' }, t('Choose file to upload')))) : (react.createElement(react.Fragment, null,
                react.createElement(styles_css/* Link */.rU, { name: 'body', size: 'medium', color: Colors/* colors.primary.40 */.O9.primary[40], href: '#', onClick: function (e) {
                        var _a;
                        e.preventDefault();
                        if (!(file === null || file === void 0 ? void 0 : file.id)) {
                            return;
                        }
                        (0,helpers/* downloadAttachFile */.jE)({
                            resumeId: file === null || file === void 0 ? void 0 : file.id,
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            msBaseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                            fileName: (_a = file === null || file === void 0 ? void 0 : file.name) !== null && _a !== void 0 ? _a : ''
                        });
                    }, target: '_blank', isDragging: isDrag },
                    react.createElement(Variant/* Span */.Dr, { name: 'body', size: 'medium', color: Colors/* colors.primary.40 */.O9.primary[40], style: { width: '100%', marginLeft: 4, textAlign: 'unset' } },
                        react.createElement(DocumentsIcon, { style: { marginBottom: -1 } }),
                        " ",
                        react.createElement("span", null, file.name)))))))),
        react.createElement(styles_css/* ResponseMsg */.bU, { variant: 'p', name: 'body', size: boxType === type/* EBoxType.primary */.Y.primary ? 'small' : 'medium', isPlaceholder: !isError, color: renderResponseMsgColor() },
            (contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.customMsg) ? (react.createElement(react.Fragment, null, contentOptions === null || contentOptions === void 0 ? void 0 :
                contentOptions.customMsg,
                react.createElement("br", null))) : (''),
            message || t('.doc, .docx and .pdf files that are less than 5120KB in size')),
        boxType === type/* EBoxType.secondary */.Y.secondary && (file === null || file === void 0 ? void 0 : file.name) ? (react.createElement(styles_css/* ReplaceButton */.CX, { outline: 'outline', size: 'md', type: 'default' }, t('Replace file'))) : null));
};
var DragDropResumeUpload$1 = (0,react.forwardRef)(DragDropResumeUpload);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 1556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AttachIcon$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var AttachIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 18 : _b, _c = _a.height, height = _c === void 0 ? 18 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.color, color = _e === void 0 ? '#616161' : _e;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 20 20', fill: 'none' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M12.8686 1.66797C11.8864 1.66797 10.9051 2.0571 10.1693 2.83333L4.83081 8.46484C2.83472 10.5713 2.83472 13.9574 4.83081 16.0638C4.89234 16.1286 4.96629 16.1805 5.04825 16.2161C5.04955 16.2166 5.05086 16.217 5.05216 16.2174C7.06325 18.1232 10.2002 18.1019 12.1316 16.0638L15.8868 12.1016C15.9504 12.0387 16.0007 11.9637 16.0347 11.8811C16.0687 11.7984 16.0857 11.7097 16.0848 11.6203C16.0838 11.531 16.0649 11.4427 16.0291 11.3607C15.9934 11.2788 15.9415 11.2049 15.8766 11.1434C15.8117 11.0819 15.7352 11.0341 15.6514 11.0028C15.5677 10.9716 15.4785 10.9574 15.3892 10.9613C15.2999 10.9652 15.2123 10.987 15.1316 11.0254C15.0508 11.0638 14.9787 11.118 14.9193 11.1849L11.1641 15.1471C9.66295 16.7313 7.30074 16.7313 5.79956 15.1471C4.29831 13.5629 4.29831 10.9657 5.79956 9.38151L11.1368 3.75C12.1133 2.71981 13.6252 2.71981 14.6016 3.75C15.578 4.78009 15.578 6.48033 14.6016 7.51042L9.74357 12.6367C9.29097 13.1139 8.6303 13.1135 8.17846 12.6367C7.72662 12.1599 7.72662 11.357 8.17846 10.8802L12.086 6.75651C12.1496 6.69367 12.1999 6.61868 12.2339 6.53601C12.2679 6.45334 12.2849 6.36468 12.284 6.27529C12.283 6.1859 12.2641 6.09762 12.2284 6.01569C12.1926 5.93376 12.1407 5.85986 12.0759 5.79838C12.011 5.73689 11.9344 5.68909 11.8506 5.6578C11.7669 5.62651 11.6777 5.61238 11.5884 5.61625C11.4991 5.62012 11.4115 5.64191 11.3308 5.68032C11.2501 5.71873 11.1779 5.77298 11.1186 5.83984L7.20971 9.96354C6.26289 10.9627 6.26289 12.5542 7.20971 13.5534C7.27291 13.6199 7.34915 13.6726 7.43367 13.7083C8.3941 14.5107 9.82882 14.4835 10.711 13.5534L15.5691 8.42708C16.98 6.93856 17.0003 4.60906 15.7058 3.04948C15.6746 2.96928 15.6282 2.89588 15.5691 2.83333C14.8333 2.0571 13.8508 1.66797 12.8686 1.66797Z', fill: color })));
};
var AttachIcon$1 = react__WEBPACK_IMPORTED_MODULE_0__.memo(AttachIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 19357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Skeleton; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
'use client';





var shimmer = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(templateObject_1 || (templateObject_1 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__makeTemplateObject */ .cy)(["\n    100% {\n        transform: translateX(100%);\n    }\n"], ["\n    100% {\n        transform: translateX(100%);\n    }\n"])));
var StyledSkeleton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(templateObject_2 || (templateObject_2 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__makeTemplateObject */ .cy)(["\n    display: block;\n    height: ", "px;\n    width: ", ";\n    position: relative;\n    overflow: hidden;\n    background-color: #efefef;\n    border-radius: 4px;\n\n    &::after {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        transform: translateX(-100%);\n        background: linear-gradient(\n            90deg,\n            rgba(255, 255, 255, 0) 0,\n            rgba(255, 255, 255, 0.2) 20%,\n            rgba(255, 255, 255, 0.5) 60%,\n            rgba(255, 255, 255, 0)\n        );\n        animation: ", " 2s infinite forwards;\n        content: '';\n    }\n"], ["\n    display: block;\n    height: ", "px;\n    width: ", ";\n    position: relative;\n    overflow: hidden;\n    background-color: #efefef;\n    border-radius: 4px;\n\n    &::after {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        transform: translateX(-100%);\n        background: linear-gradient(\n            90deg,\n            rgba(255, 255, 255, 0) 0,\n            rgba(255, 255, 255, 0.2) 20%,\n            rgba(255, 255, 255, 0.5) 60%,\n            rgba(255, 255, 255, 0)\n        );\n        animation: ", " 2s infinite forwards;\n        content: '';\n    }\n"])), function (props) { return props.height; }, function (props) { return (props.width ? "".concat(props.width, "px") : '100%'); }, shimmer);
function Skeleton(props) {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSkeleton, (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, props));
}
var templateObject_1, templateObject_2;


//# sourceMappingURL=index.js.map


/***/ })

}]);